import { Route, Routes } from 'react-router-dom';
import { BoothPage } from './pages/BoothPage';
import { BuilderPage } from './pages/BuilderPage';
import { CustomBoothPage } from './pages/CustomBoothPage';
import { GalleryPage } from './pages/GalleryPage';
import { WallPage } from './pages/WallPage';
import { BoothAdminPage } from './pages/BoothAdminPage';
import { BoothDeletePage } from './pages/BoothDeletePage';
import { BoothPasswordResetPage } from './pages/BoothPasswordResetPage';
import { SharePage } from './pages/SharePage';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<BoothPage />} />
      <Route path="/builder" element={<BuilderPage />} />
      {/* Default-booth share pages (rendered by Lambda for crawlers,
          rendered as SPA preview here for humans). */}
      <Route path="/share/p/:id" element={<SharePage kind="photo" />} />
      <Route path="/share/v/:id" element={<SharePage kind="video" />} />
      {/* Custom-booth share pages: /share/p/:slug/:id and /share/v/:slug/:id */}
      <Route path="/share/p/:slug/:id" element={<SharePage kind="photo" />} />
      <Route path="/share/v/:slug/:id" element={<SharePage kind="video" />} />
      {/* Per-booth sub-routes */}
      <Route path="/:slug/gallery" element={<GalleryPage />} />
      <Route path="/:slug/wall" element={<WallPage />} />
      <Route path="/:slug/delete" element={<BoothDeletePage mode="request" />} />
      <Route path="/:slug/delete/confirm" element={<BoothDeletePage mode="confirm" />} />
      <Route path="/:slug/reset" element={<BoothPasswordResetPage />} />
      <Route path="/:slug/admin" element={<BoothAdminPage />} />
      {/* Custom booth runtime — anything else single-segment is treated as a slug. */}
      <Route path="/:slug" element={<CustomBoothPage />} />
      <Route path="*" element={<BoothPage />} />
    </Routes>
  );
}
